import { AuthService } from './../../../../services/auth.service';
import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('sidebar', [
      transition(':enter', [
        style({
          left: '-300px'
        }),
        animate('300ms', style({
          left: 0
        }))
      ]),
      transition(':leave', [
        style({
          left: '0'
        }),
        animate('300ms', style({
          left: '-300px'
        }))
      ]),
    ])
  ]

})
export class HeaderComponent {

  @Input('social') social: any;

  showSidebar = false;

  isLoggedIn: Observable<boolean>;
  isAdmin: Observable<boolean>;

  constructor(private auth: AuthService, private router: Router) {
    this.isLoggedIn = auth.isAuthenticated();
    this.isAdmin = auth.isSchoolAdmin();
  }

  logout(){
    this.auth.logout();
    this.router.navigate(['/']);
  }

  navigate(url){
    this.router.navigate([url]);
  }
}
